import { CSSProperties } from 'react';

export function defineTheme<T extends { colors: Record<string, CSSProperties['color']> }>(theme: T): T {
  return theme;
}

const theme = defineTheme({
  colors: {
    roseMain: '#960045',
    blue: '#003972',
    blueLight: '#F1F5F9',
    blue200: '#BFD1E3',
    functionalYellow: '#FFB03D',
    functionalYellowLight: '#FFEED6',
    functionalGreen: '#2D970C',
    functionalGreenLight: '#E6F4E1',
    functionalRedLight: '#FDE8E8',
    functionalRed: '#4D0021',
    contrastWhite: '#FFFFFF',
    contrastBlack: '#000000',
    grey: '#99A0A3',
    greyMain: '#4D5356',
    grey300: '#B4B9BB',
    grey50: '#F4F5F5',
  },
  typography: {
    fontFamily: 'FF DIN Web Pro, sans-serif',
    fontWeight: {
      regular: 400,
      bold: 700,
    },
  },
  borderRadius: {
    card: 8,
    badge: 4,
  },
  shadows: {
    card: '0px 1px 7px rgba(8, 38, 69, 0.06)',
  },
});

export default theme;
